export default {
	unauthtorized: 'твой аккаунт',
};
